import { useState, useEffect } from "react";
import styles from "./Footer.module.scss";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../../api/sanityClient";
import { useSiteConfig } from "../../App";
import Sponsors from "../Sponsors/Sponsors";

const builder = imageUrlBuilder(sanityClient);
const urlFor = (source) => builder.image(source);

const Footer = ({}) => {


  return (
    <footer className={styles.footer}>
      <div className={styles.innerContainer}>
        <h2 className={styles.title}>Our Sponsors</h2>
        <Sponsors/>
        <a href="https://www.meetup.com/ixda-stavanger" target="_blank" rel="noopener noreferrer" className={styles.link}>
          IxDA SVG on Meetup.com →
        </a>
      </div>
    </footer>
  );
};

export default Footer;
